import { MapLocation } from '@/types/location';

export const muhayilDigitalMegacomScreens: MapLocation[] = [
  {
    id: 10064,
    name: "Digital Megacom Screen – Muhayil",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [18.537083, 42.057861],
    region: "Muhayil",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/3c461221-ebbb-48a4-bb51-e1a6f0988658.png"
    }
  },
  {
    id: 10073,
    name: "Digital Megacom Screen – Muhayil 2",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [18.537083, 42.057861],
    region: "Muhayil",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/b1dae017-5557-4814-a716-a2d561036b57.png"
    }
  },
  {
    id: 10074,
    name: "Digital Megacom Screen – Muhayil 3",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [18.542028, 42.038944],
    region: "Muhayil",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/e84abb70-4a0a-4095-8e12-f3de7b92d225.png"
    }
  },
  {
    id: 10075,
    name: "Digital Megacom Screen – Muhayil 4",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [18.553944, 42.041944],
    region: "Muhayil",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/81aadcaf-f9e2-4efc-82fd-aad2237dd3e9.png"
    }
  },
  {
    id: 10076,
    name: "Digital Megacom Screen – Muhayil 5",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [18.539500, 42.041333],
    region: "Muhayil",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/1f17f001-2385-4e0c-ad56-8c8cbcf46552.png"
    }
  }
];